// @flow
import * as React from 'react';
import { isChrome } from 'utils/browser';
import { updateObject } from 'utils/functional';
import AutocompleteTextInput, {
  type AutocompleteType
} from 'components/AutocompleteTextInput';
import Field from './Field';

const AutocompleteInputField = ({
  name,
  label,
  description,
  type = 'text',
  mapError,
  autoComplete,
  large,
  customErrorMatch,
  hasError,
  ...props
}: {
  name: string,
  label?: React.Node,
  description?: React.Node,
  type?: string,
  mapError?: string => React.Node,
  autoComplete?: string,
  autocompleteType: AutocompleteType,
  large?: boolean,
  customErrorMatch?: Function,
  hasError?: boolean
}) => {
  const autoCompleteString =
    autoComplete === 'off' && isChrome() ? 'foobar' : autoComplete;
  const inputProps = autoComplete
    ? updateObject(props, { autoComplete: autoCompleteString })
    : props;
  return (
    <Field
      customErrorMatch={customErrorMatch}
      inputProps={inputProps}
      name={name}
      label={label}
      description={description}
      mapError={mapError}
      renderInput={({
        value,
        id,
        qaId,
        hasError: formHasError,
        updateValue
      }) => (
        <AutocompleteTextInput
          id={id}
          name={name}
          type={type}
          value={value || ''}
          hasError={formHasError || !!hasError}
          data-qa-id={qaId}
          onChange={e => {
            updateValue(e.target.value);
          }}
          onKeyPress={e => {
            // Prevents form submission for CMS create/edit page.
            if (e.key === 'Enter') {
              e.preventDefault();
            }
          }}
          large={large}
          {...inputProps}
        />
      )}
    />
  );
};

export default AutocompleteInputField;
